<template>
  <div class="row-root">
    <div class="row-main">
      <div class="icon-well" aria-hidden="true">{{ ICONS.inspectKinds.player }}</div>
      <div class="content">
        <div class="topline">
          <div class="name" :title="player.name">{{ player.name }}</div>
          <UiChip v-if="player.level != null" variant="muted">Lv <span class="stat-mono num">{{ formatNumber(player.level) }}</span></UiChip>
        </div>
        <div class="subline text-muted">Adventurer</div>
      </div>
    </div>

    <div class="row-actions">
      <UiButton size="sm" variant="secondary" @click="emit('inspect', player)">
        <template #icon>{{ ICONS.actions.inspect }}</template>
        Inspect
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICONS } from "../../../lib/icons";
import { formatNumber } from "../../../lib/format";
import UiButton from "../../ui/UiButton.vue";
import UiChip from "../../ui/UiChip.vue";

export type PlayerRowModel = {
  id: string;
  name: string;
  level?: number;
};

defineProps<{
  player: PlayerRowModel;
}>();

const emit = defineEmits<{
  inspect: [player: PlayerRowModel];
}>();
</script>

<style scoped>
.row-root {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0.75rem 0.8rem;
  border-radius: var(--radius-2);
  border: 1px solid var(--glass-border-0);
  background: var(--glass-0);
}

.row-main {
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  min-width: 0;
}

.icon-well {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-1);
  display: grid;
  place-items: center;
  background: var(--glass-1);
  border: 1px solid var(--glass-border-1);
  flex: 0 0 auto;
}

.content {
  min-width: 0;
  display: grid;
  gap: 0.25rem;
}

.topline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.name {
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: min(320px, 46vw);
}

.subline {
  font-size: 0.9rem;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
</style>
